import React from 'react'

function Button({ type, buttonClass, buttonText, onClick }) {
    return (
        <button type={type ? type : 'button'} className={`btn rounded-3 ${buttonClass}`} onClick={onClick}>{buttonText}</button>

    )
}

export default Button